import { useQuery } from '@tanstack/react-query';
import { useCompany } from '@/contexts/CompanyContext';
import { useDirection } from '@/contexts/DirectionContext';
import { containersApi } from '../api/containers.api';
import type { ContainerModalData } from '../interfaces/container.interface';

interface UseContainerModalResult {
  data: ContainerModalData | undefined;
  isLoading: boolean;
  isFetching: boolean;
  error: Error | null;
}

/**
 * Fetch lazy al datelor pentru modal-ul de container. Se activează doar când
 * `id` e număr valid; altfel nu face request (query disabled).
 */
export function useContainerModal(id: number | null | undefined): UseContainerModalResult {
  const { selectedCompanyId } = useCompany();
  const { direction } = useDirection();
  const companyId = typeof selectedCompanyId === 'number' ? selectedCompanyId : undefined;

  const query = useQuery<ContainerModalData>({
    queryKey: ['containers', 'modal', id, selectedCompanyId, direction],
    queryFn: () => containersApi.getModalData(id as number, companyId, direction),
    enabled: typeof id === 'number' && id > 0,
    staleTime: 60 * 1000,
    refetchOnWindowFocus: false,
  });

  return {
    data: query.data,
    isLoading: query.isLoading,
    isFetching: query.isFetching,
    error: (query.error as Error) || null,
  };
}
